var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSharedContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58,28.75A3.25377,3.25377,0,0,1,61.25,32h1.5A4.7554,4.7554,0,0,0,58,27.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58,24.75A7.25834,7.25834,0,0,1,65.25,32h1.5A8.76,8.76,0,0,0,58,23.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.25,32h1.5A12.76457,12.76457,0,0,0,58,19.25v1.5A11.26294,11.26294,0,0,1,69.25,32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76416,22a1.25116,1.25116,0,0,1,1.25-1.25H54v-1.5H12.01416a2.7528,2.7528,0,0,0-2.75,2.75V56a2.7528,2.7528,0,0,0,2.75,2.75h27.25v2.5h-13.25v1.5h28v-1.5h-13.25v-2.5h27.25a2.7528,2.7528,0,0,0,2.75-2.75V36h-1.5V51.25h-58.5Zm58.5,30.75V56a1.25116,1.25116,0,0,1-1.25,1.25h-56a1.25116,1.25116,0,0,1-1.25-1.25V52.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 32,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharedContent);
export default __webpack_public_path__ + "static/media/icon_shared_content.52db8fdd3bc0d45ac8ba74a444ff18c8.svg";
export { ForwardRef as ReactComponent };